const firebaseConfig = {
    name: "Schoeningh",
    registrationEnabled: true,
    apiKey: "AIzaSyAuy27CM420hvEAmipLdEvCff-yBPgwUJU",
    authDomain: "litport-schoeningh.firebaseapp.com",
    projectId: "litport-schoeningh",
    storageBucket: "litport-schoeningh.appspot.com",
    messagingSenderId: "405245905992",
    appId: "1:405245905992:web:27684a39b1ee0ea2cedc7d",
    imgSrc: "/img/logo_schoeningh.svg",
    imgWidth: "160px",
    imprintLink: "https://www.schoeningh-buch.de/impressum",
    privacyLink: "https://www.schoeningh-buch.de/datenschutz",
    siteUrl: "https://litport.schoeningh-buch.de",
    favIcon: "/img/favicon.ico",
    email: ["abo@schoeningh-buch.de" ],   
    emailEdi: ["abo@schoeningh-buch.de" ],   
    emailDebug: []
};
export default firebaseConfig;
